<div class="app-header">
  <app-header></app-header>
</div>
<div class="app-main">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
